import { memo } from 'react';
import styled from 'styled-components';

const StyledFieldset = styled.fieldset`
  width: ${(props) =>
    props.forlegend === 'true' ? `calc(100% - 62px)` : `auto`};
  height: auto;
  margin: 0px 0px 20px 0px;
  padding: ${(props) => (props.forlegend === 'true' ? `25px 30px` : `0px`)};
  border: ${(props) =>
    props.forlegend === 'true' ? `1px solid #e1e1e1` : `0px`};
  border-radius: 0px;
  position: relative;
  display: ${(props) => props.display || 'flex'};
  flex-direction: row;
  align-items: center;
  @media (max-width: 600px) {
    display: block;
  }
`;

const Fieldset = memo(({ children, display = 'flex', ...rest }) => {
  return (
    <StyledFieldset {...rest} display={display}>
      {children}
    </StyledFieldset>
  );
});

export default Fieldset;
